// extracted by mini-css-extract-plugin
export default {"textarea":"style_textarea__rtTpD"};